import React from 'react'
import { Box } from '@mui/joy';
import HeaderTwo from '../component/header/HeaderTwo';
import Footer from '../component/footer/Footer';
import Breadcrumb from '.././component/common/Breadcrumb';
import JobPostForm from '../element/JobPostForm';


const JobPage = () => {

  return (
    <>
      <Box
        sx={{
          width:'100%',
          padding: '0',
          backgroundColor: '#fff',
          boxSizing: 'border-box',

        }}
      >
        <HeaderTwo />
        <Breadcrumb parent="Home" title="Post a job" />
        <JobPostForm />
        <Footer />
      </Box>

    </>
  )
}

export default JobPage;